module.exports = __webpack_public_path__ + "static/img/best_visual_effects_mob.821e487.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/best_visual_effects_mob.jpg
// module id = 88
// module chunks = 0